import { Html, useProgress } from "@react-three/drei";

const ModelLoader = () => {
  const { progress } = useProgress();

  return (
    <Html center>
      <div className="flex flex-col items-center gap-3">
        {/* Spinner */}
        <div className="w-10 h-10 border-4 border-gray-300 border-t-primary rounded-full animate-spin" />

        {/* Progress */}
        <span className="text-sm text-gray-600 font-medium">
          Loading {Math.round(progress)}%
        </span>
      </div>
    </Html>
  );
};

export default ModelLoader;
